<template>
  <div>
      <b-card 
        title="Product"
      >
        <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <label
            class="mr-1"
          >
              Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block mr-1"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>

    </div>
        <b-table 
          responsive
          :sort-by.sync="sortBy" 
          :sort-desc.sync="sortDesc" 
          :items="items" 
          :fields="fields" 
          :no-local-sorting="true" 
          @sort-changed="sortingChanged"
          :busy="isBusy"
          @row-selected="onRowSelected"
          selectable
          :select-mode="'single'"
        >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
                <strong class="text-secondary">Loading...</strong>
              </div>
            </template>
            
            <template #cell(name)="data">
              <div>{{ data.item.first_name + " " + data.item.last_name }}</div>
            </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ currentPage * perPage - perPage + 1 }} to {{ currentPage * perPage - perPage + showData  }} of {{ totalData }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="inputPagination"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
      <b-modal
        id="image-review"
        scrollable
        title="Image Review"
        ok-title="Close"
        centered
        cancel-variant="outline-secondary"
        :ok-only="true"
        size="md"
        @row-selected="onRowSelected"
      >
          <b-card-text
          >
              <b-row class="justify-content-center">
                  <b-col md="8" sm="4">
                      <b-img
                        thumbnail
                        fluid
                        rounded
                        :src="imgSelectedItem"
                      >

                      </b-img>
                  </b-col>
              </b-row>
          </b-card-text>
      </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BSpinner, BFormCheckbox, BModal, BImg
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
  },
  props: {
    setItem: Function
  },
  data() {
    return {
      perPage: '10',
      perPageOptions: ['10', '20', '30'],
      currentPage: 1,
      totalData: 0,
      showData: 0,
      fields: [
        { key: 'KODE', label: 'kode', sortable: true},
        { key: 'PRODUCT', label: 'product', sortable: true},
        { key: 'PROD_CATEGORY', label: 'category'},
        { key: 'DIVISION', label: 'division / cfu'},
        'status',
      ],
      items: [],
      sortBy: 'id',
      sortDesc: true,
      searchWord: '',
      isBusy: false,

      selectedItem: {
        icon: '',
        icon_details: {}
      }
    }
  },
  directives: {
    Ripple,
  },
  computed: {
    skip() {
      return this.perPage * (this.currentPage - 1)
    },
    imgSelectedItem() {
      return typeof this.selectedItem.icon_details === 'object' && typeof this.selectedItem.icon_details.original === 'object' ? this.selectedItem.icon_details.original.url : ''
    }
  },
  watch: {
    perPage() {
      this.getProduct()
    },
    currentPage() {
      this.getProduct()
    },
    searchWord() {
      this.$store.dispatch('app/search', {
        callback: () => {
          this.getProduct()
        }
      })
    }
  },
  mounted() {
    this.getProduct()
  },
  methods: {
    async getProduct() {
      let searchWord  = this.searchWord.trim()
      let base = '/product/with.total/true'
      let take = `/take/${this.perPage}`
      let skip = `/skip/${this.skip}`
      let search = `${searchWord !== '' ? `/s/${searchWord}`: ''}`
      let orderBy = `/orderBy.${this.sortBy}/${this.sortDesc === true ? 'desc' : 'asc'}`
      let complete = base + take + skip + search + orderBy
      this.isBusy = true
      return await this.$http.get(complete)
      .then( res => {
        this.items = res.data.data.records
        this.totalData = res.data.data.total
        this.showData = res.data.data.show
      })
      .catch( err => {
        console.error(err)
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    inputPagination(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc}) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.getProduct()
      }
    },
    onRowSelected(item, loading) {
        let selectedItem = null
        if (item.length > 0 ) {
            selectedItem = item[0]
        }
        this.setItem(item)
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>